// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import { alertColor } from './colors'
import spinnerImg from '../../images/main/spinner.svg'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
  ${({ isCompact }: Object) =>
    isCompact
      ? ''
      : `
    float: left;
    margin: 0 10px 0;
  `}
`
const Buffer: StyledComponent<Object, any, any> = styled.div`
  width: 112%;
  height: 112%;
  position: absolute;
  z-index: 1;
  margin-left: -2%;
  margin-top: -2%;
  cursor: pointer;
  ${({ isLoading }: Object) =>
    isLoading
      ? `
    background: url(${spinnerImg}) center center no-repeat;
    background-size: 60%;
    cursor: default;
  `
      : ''}
`
const Canvas: StyledComponent<Object, any, any> = styled.div`
  display: block;
  width: 31px;
  height: 17px;
  background: ${alertColor};
  border-radius: 50px;
  position: relative;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(255, 255, 255, 0.2);
  &:after {
    content: '';
    display: block;
    width: 19px;
    height: 19px;
    border-radius: 50px;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    cursor: pointer;
    position: absolute;
    top: -1px;
    left: -3px;
    border: 1px solid #b8b8b8;
    background: #fff;
  }
  ${({ isChecked }: Object) =>
    isChecked
      ? `
    background: #2da1c4;
    &:after {
      left: 15px;
    }`
      : ''}
`

type Props = {|
  loading?: boolean,
  checked: boolean,
  isCompact?: boolean,
  onChange?: (boolean) => void
|}

export default class StateSwitcher extends Component<Props> {
  render() {
    return (
      <Wrapper isCompact={this.props.isCompact} className="t-StateSwitcher">
        <Buffer
          isLoading={this.props.loading}
          className={this.props.loading ? 't-StateSwitcher__loading' : void 0}
          onClick={() => this.clicked()}
        />
        <Canvas isChecked={this.props.checked} />
      </Wrapper>
    )
  }

  clicked() {
    if (this.props.loading) return

    this.props.onChange && this.props.onChange(!this.props.checked)
  }
}
